import { FC } from "react";
import { Icon, IconProps } from "@chakra-ui/react";

export const Medium: FC<IconProps> = ({
  fill = "none",
  height = "3rem",
  viewBox = "0 0 54 28",
  width = "3rem",
  ...props
}) => (
  <Icon fill={fill} height={height} viewBox={viewBox} width={width} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.0749 13.8866C27.0749 21.428 21.0139 27.5415 13.5377 27.5415C6.06146 27.5415 0 21.4267 0 13.8866C0 6.34655 6.061 0.231201 13.5377 0.231201C21.0143 0.231201 27.0749 6.34517 27.0749 13.8866ZM41.9244 13.8866C41.9244 20.9853 38.8939 26.7421 35.1556 26.7421C31.4172 26.7421 28.3867 20.9853 28.3867 13.8866C28.3867 6.788 31.4168 1.03113 35.1551 1.03113C38.8934 1.03113 41.9239 6.78615 41.9239 13.8866H41.9244ZM45.6184 25.4031C46.9334 25.4031 47.9991 20.2453 47.9991 13.8866C47.9991 7.52614 46.9329 2.37012 45.6184 2.37012C44.3039 2.37012 43.2383 7.5266 43.2383 13.8866C43.2383 20.2466 44.3035 25.4031 45.6184 25.4031Z"
      fill="currentColor"
    />
  </Icon>
);
